import * as React from 'react';
import { Previous, Next } from '../../assets/icons';

interface WhyProps {
  truncated: JSX.Element
  expanded: JSX.Element
  illustration: string
  colour: string
  previous?: () => void
  next?: () => void
  skip?: () => void
}

class Why extends React.Component<WhyProps, { expanded: boolean }> {
  constructor(props: WhyProps) {
    super(props);
    this.state = { expanded: false };
  }

  public render() {
    return (
      <div className='why-component'>
        <div className={`why-header ${this.props.colour}`}>
          <img src={this.props.illustration} />
        </div>
        <div className='why-content'>
          { this.props.truncated }
          <button onClick={this.readMore} className={`button primary-button read-more ${this.state.expanded ? 'expanded' : ''}`}>Read more</button>
          <div className={`full-content ${this.state.expanded ? 'expanded' : ''}`}>
            { this.props.expanded }
          </div>
        </div>
        <div className='why-footer'>
          <div className='why-nav-buttons'>
            <button 
              disabled={!this.props.previous} 
              onClick={this.props.previous}
              className='button primary-button icon-button'
            >
              <Previous />
            </button>
            <button 
              disabled={!this.props.next} 
              onClick={this.props.next}
              className='button primary-button icon-button'
            >
              <Next />
            </button>
          </div>
          <button className='button link-button' onClick={this.props.skip}>Skip all</button>
        </div>
      </div>
    );
  }

  private readMore = () => this.setState({expanded: true});
}

export default Why;
